import { get, filter, sortBy, forEach, map } from "lodash";
import { fetchGet } from "../api/fetch";
import { isAllowed } from "./users";

export const getDevicesTree = (res, companyId, siteId, zoneId) => {
  let devices = map(
    filter(res, (d) => get(d, ["device_type_id"]) === 1),
    (d) => ({
      ...d,
      company_id: companyId,
      site_id: siteId,
      zone_id: zoneId,
      external_devices: [],
    })
  );
  forEach(
    filter(res, (d) => get(d, ["device_type_id"]) !== 1),
    (item) => {
      if (get(item, ["parent_device_id"])) {
        get(
          filter(devices, (d) => d.id === get(item, ["parent_device_id"])),
          [0, "external_devices"]
        ).push({
          ...item,
          company_id: companyId,
          site_id: siteId,
          zone_id: zoneId,
        });
      } else {
        devices.push({
          ...item,
          company_id: companyId,
          site_id: siteId,
          zone_id: zoneId,
        });
      }
    }
  );
  return sortBy(devices, (d) => -get(d, ["device_type_id"]));
};

export const getAccessibleCompanies = async (
  permissions,
  assignedCompany,
  assignedSite
) => {
  try {
    const zones = await fetchGet("zones/search");
    let sites = {};
    forEach(
      filter(zones, (zone) => get(zone, ["zone_active"])),
      (zone) => {
        if (get(sites, [get(zone, ["site_id"])])) {
          sites[get(zone, ["site_id"])].zones.push({
            ...get(zone, ["zone"]),
            type: get(zone, ["zone", "type", "id"]),
            is_human_access: get(zone, ["is_human_access"]),
            is_vehicle_access: get(zone, ["is_vehicle_access"]),
            is_train_access: get(zone, ["is_train_access"]),
            is_entrance: get(zone, ["is_entrance"]),
            is_exit: get(zone, ["is_exit"]),
          });
        } else {
          sites[get(zone, ["site_id"])] = {
            ...get(zone, ["site"]),
            site: get(zone, ["site"]),
            company: get(zone, ["company"]),
            company_id: get(zone, ["company_id"]),
            company_name: get(zone, ["company_name"]),
            company_active: get(zone, ["company_active"]),
            zones: [
              {
                ...get(zone, ["zone"]),
                type: get(zone, ["zone", "type", "id"]),
                is_human_access: get(zone, ["is_human_access"]),
                is_vehicle_access: get(zone, ["is_vehicle_access"]),
                is_train_access: get(zone, ["is_train_access"]),
                is_entrance: get(zone, ["is_entrance"]),
                is_exit: get(zone, ["is_exit"]),
              },
            ],
          };
        }
      }
    );
    sites = map(
      sortBy(sites, (s) => s.id),
      (s) => ({
        ...s,
        zones: sortBy(s.zones, (z) => z.id),
      })
    );

    let companies = {};
    forEach(
      filter(sites, (site) => get(site, ["active"])),
      (site) => {
        if (get(companies, [get(site, ["company_id"])])) {
          companies[get(site, ["company_id"])].sites.push({
            ...get(site, ["site"]),
            zones: get(site, ["zones"]),
          });
        } else {
          companies[get(site, ["company_id"])] = {
            ...get(site, ["company"]),
            sites: [{ ...get(site, ["site"]), zones: get(site, ["zones"]) }],
          };
        }
      }
    );
    companies = map(
      sortBy(companies, (c) => c.id),
      (c) => ({
        ...c,
        sites: sortBy(c.sites, (s) => s.id),
      })
    );

    // User cannot access all companies
    if (!isAllowed(permissions, "access.cross.companies.read")) {
      companies = filter(companies, (c) => c.id === assignedCompany);
    }

    // User cannot access all sites
    if (!isAllowed(permissions, "access.cross.sites.read")) {
      companies = map(companies, (c) => ({
        ...c,
        sites: filter(get(c, ["sites"]), (s) => s.id === assignedSite),
      }));
    }

    return companies;
  } catch (e) {
    console.log(e);
  }
  return [];
};
